import { render } from "./ShowcasePlaceholders.vue?vue&type=template&id=6abce086"
import script from "./ShowcasePlaceholders.vue?vue&type=script&lang=js"
export * from "./ShowcasePlaceholders.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rob/Projects/LaneLabs/portfolio/wp-content/themes/thelane/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__